import L from 'leaflet';
import type { Map as LeafletMap, LatLng } from 'leaflet';

export const CADASTRAL_IDENTIFY_URL = 'https://api3.geo.admin.ch/rest/services/ech/MapServer/identify';
export const CADASTRAL_LAYER_NAME = 'ch.kantone.cadastralwebmap-farbe';

type GeoAdminIdentifyResult = {
  geometry?: unknown;
  feature?: {
    geometry?: unknown;
  };
  attributes?: Record<string, unknown>;
  properties?: Record<string, unknown>;
  layerBodId?: string;
  label?: string;
  featureId?: string | number;
  id?: string | number;
  [key: string]: unknown;
};

type GeoAdminIdentifyResponse = {
  results?: GeoAdminIdentifyResult[];
  [key: string]: unknown;
};

export type GeoAdminIdentifyFeature = GeoAdminIdentifyResult & {
  geometry: unknown;
  properties: Record<string, unknown>;
};

const getMapCrs = (map: LeafletMap) => {
  const crs = map.options.crs;
  if (!crs) {
    throw new Error('Leaflet map CRS is not available.');
  }
  return crs;
};

const projectLatLng = (map: LeafletMap, latlng: LatLng) => getMapCrs(map).project(L.latLng(latlng.lat, latlng.lng));

export const getMapExtentString = (map: LeafletMap): string => {
  const bounds = map.getBounds();
  const southWest = projectLatLng(map, bounds.getSouthWest());
  const northEast = projectLatLng(map, bounds.getNorthEast());

  return `${southWest.x},${southWest.y},${northEast.x},${northEast.y}`;
};

export const getImageDisplayString = (map: LeafletMap): string => {
  const size = map.getSize();
  return `${size.x},${size.y},96`;
};

export const getSwissPointStringFromLatLng = (map: LeafletMap, latlng: LatLng): string => {
  const point = projectLatLng(map, latlng);
  return `${point.x},${point.y}`;
};

export const extractFirstFeature = (
  response: GeoAdminIdentifyResponse | null | undefined
): GeoAdminIdentifyFeature | null => {
  if (!response) return null;

  const result = response?.results?.[0];
  if (!result) return null;

  const geometry = result.geometry || result.feature?.geometry || null;
  if (!geometry) return null;

  return {
    ...result,
    geometry,
    properties: {
      ...(result.attributes || {}),
      ...(result.properties || {}),
      layerBodId: result.layerBodId,
      label: result.label,
      featureId: result.featureId,
      id: result.id,
    },
  };
};
